import React from 'react';
import './ProductWhyGenix.css';

const ProductWhyGenix = () => {
  return (
    <section className="product-why-genix-section">
      <div className="product-why-genix-container">
        <div className="product-why-genix-content">
          <h2>Why Genix HR?<br />Hear It From Our Leaders</h2>
          <ul>
            <li>
              <svg className="checkmark" viewBox="0 0 24 24">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
              </svg>
              Handles complex shift rosters.
            </li>
            <li>
              <svg className="checkmark" viewBox="0 0 24 24">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
              </svg>
              Supports license and training record tracking.
            </li>
            <li>
              <svg className="checkmark" viewBox="0 0 24 24">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
              </svg>
              Ensures GDPR & NHS compliance
            </li>
            <li>
              <svg className="checkmark" viewBox="0 0 24 24">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
              </svg>
              Tailored for multi-role medical staff management
            </li>
          </ul>
          <button className="start-trial-button">
            Start free trial
            <svg className="arrow" viewBox="0 0 24 24">
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>
        </div>
        <div className="product-why-genix-image-box">
          <img src="/images/WhyGenixSir.png" alt="Why Genix HR Leaders" className="product-why-genix-image" />
        </div>
      </div>
    </section>
  );
};

export default ProductWhyGenix; 